export let hrms75eColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineType: 'lov',
    lovType: 'codempid',
    eventName: 'codempid'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '100',
    style: 'min-width: 200px;',
    class: 'align-center',
    inlineType: 'lov',
    lovType: 'codcours',
    eventName: 'codcours'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '110',
    style: 'min-width: 180px;',
    eventName: 'cours'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '70',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codjob',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '80',
    style: 'min-width: 120px;'
  }, {
    key: 'numlvl',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'typemp',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '120',
    style: 'min-width: 120px;'
  }, {
    key: 'des_staappr',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'remarkap',
    name: '',
    labelCodapp: 'HRMS75EC1',
    labelIndex: '140',
    style: 'min-width: 200px;'
  }]

  let detailCoursColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '20',
    style: 'min-width: 100px;',
    inlineType: 'select',
    inlineDropdown: {}
  }]

  // let detailCoursColumns = [{
  //   key: 'codcours',
  //   name: '',
  //   labelCodapp: 'HRMS75EC7',
  //   labelIndex: '20',
  //   class: 'align-center',
  //   style: 'min-width: 100px;'
  // }, {
  //   key: 'desc_codcours',
  //   name: '',
  //   labelCodapp: 'HRMS75EC7',
  //   labelIndex: '30',
  //   style: 'min-width: 120px;'
  // }, {
  //   key: 'des_staappr',
  //   name: '',
  //   labelCodapp: 'HRMS75EC1',
  //   labelIndex: '130',
  //   style: 'min-width: 100px;'
  // }]

  let detailTab1Columns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '30',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codcate',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '40',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '50',
    style: 'min-width: 120px;'
  }, {
    key: 'qtytrmin',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;'
  }]

  let detailTab2Columns = [{
    key: 'codskill',
    name: '',
    labelCodapp: 'HRMS75EC3',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codskill',
    name: '',
    labelCodapp: 'HRMS75EC3',
    labelIndex: '80',
    style: 'min-width: 120px;'
  }, {
    key: 'score',
    name: '',
    labelCodapp: 'HRMS75EC3',
    labelIndex: '90',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'scoremp',
    name: '',
    labelCodapp: 'HRMS75EC3',
    labelIndex: '100',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'v_average',
    name: '',
    labelCodapp: 'HRMS75EC3',
    labelIndex: '110',
    class: 'align-right',
    style: 'min-width: 100px;'
  }]

  let detailTab2PopupColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codcate',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '40',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '50',
    style: 'min-width: 100px;'
  }, {
    key: 'qtytrmin',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '70',
    class: 'align-right',
    style: 'min-width: 100px;'
  }]

  let detailTab3Columns = [{
    key: 'course',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'desc_codcate',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;'

  }, {
    key: 'qtytrmin',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'position',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'qtyposst',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'qtyposen',
    name: '',
    labelCodapp: 'HRMS75EC4',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }]

  let detailTab4Columns = [{
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRMS75EC5',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS75EC5',
    labelIndex: '70',
    style: 'min-width: 120px;'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRMS75EC5',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 120px;'
  }]

  let detailTab4PopupColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codcate',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '40',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '50',
    style: 'min-width: 100px;'
  }, {
    key: 'qtytrmin',
    name: '',
    labelCodapp: 'HRMS75EC7',
    labelIndex: '70',
    class: 'align-right',
    style: 'min-width: 100px;'
  }]

  let detailTab5Columns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'dteyear',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'year'
  }, {
    key: 'dtemonth',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '80',
    style: 'min-width: 120px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'training',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'dtetrst',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'amttrexp',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '130',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'qtytotscr',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '140',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_flgtrevl',
    name: '',
    labelCodapp: 'HRMS75EC6',
    labelIndex: '150',
    style: 'min-width: 120px;'
  }]

  return {
    en: {
      index: indexColumns,
      detailCours: detailCoursColumns,
      detailTab1: detailTab1Columns,
      detailTab2: detailTab2Columns,
      detailTab2Popup: detailTab2PopupColumns,
      detailTab3: detailTab3Columns,
      detailTab4: detailTab4Columns,
      detailTab4Popup: detailTab4PopupColumns,
      detailTab5: detailTab5Columns

    },
    th: {
      index: indexColumns,
      detailCours: detailCoursColumns,
      detailTab1: detailTab1Columns,
      detailTab2: detailTab2Columns,
      detailTab2Popup: detailTab2PopupColumns,
      detailTab3: detailTab3Columns,
      detailTab4: detailTab4Columns,
      detailTab4Popup: detailTab4PopupColumns,
      detailTab5: detailTab5Columns
    }
  }
}
export let hrms75eMaxRowspan = {
  detailTab3: 2,
  detailTab5: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms75e.js